import { createSlice } from '@reduxjs/toolkit';
import { Country, Currency, OrgInfo, TimeZone } from './myOrgInfoModel';
import { editOrgInfoThunk, getOrgInfoThunk } from './myOrgInfoActions';

export interface OrgInfoData {
  loading: boolean;
  data: any;
  currencies: Currency[];
  countries: Country[];
  timeZones: TimeZone[];
}

const initialState: OrgInfoData = {
  loading: false,
  data: {} as OrgInfo,
  currencies: [],
  countries: [],
  timeZones: [],
};

const orgInfoSlice = createSlice({
  name: 'Org Info',
  initialState,
  reducers: {
    startLoading: (state) => {
      state.loading = true;
    },
    stopLoading: (state) => {
      state.loading = false;
    },
    updateCountries: (state, action) => {
      state.countries = action.payload?.data?.allCountries || [];
    },
    updateCurrencies: (state, action) => {
      state.currencies = action.payload?.data?.allCurrencies || [];
    },
    updateTimeZones: (state, action) => {
      state.timeZones = action.payload?.data?.allTimeZones || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOrgInfoThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOrgInfoThunk.fulfilled, (state, action: any) => {
        state.data = action.payload;
        state.loading = false;
      })
      .addCase(getOrgInfoThunk.rejected, (state) => {
        state.loading = false;
      })
      .addCase(editOrgInfoThunk.pending, (state) => {
        state.loading = true;
      })
      .addCase(editOrgInfoThunk.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(editOrgInfoThunk.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { startLoading, stopLoading, updateCountries, updateCurrencies, updateTimeZones } =
  orgInfoSlice.actions;
export default orgInfoSlice.reducer;
